/**
 * @author Chandra shekar
 * @Date: 2020-10-26 12:34:11
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2021-01-06 16:47:49
 */
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { func, bool, shape } from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Breadcrumb, Table, Button, Icon, Modal, Form, Input, Select } from 'antd';
import { connect } from 'react-redux';

import Container from '../../components/Container';
import { AppWrappperHOC } from '../Root/HOC';
import theme from '../../theme';
import { select_cardBlockJS, select_isBoolean } from '../NetworkCards/selectors';
import { SetComplainModule } from '../NetworkCards/actions';
import { constants, utils, validationRules } from '../../devUtils';

const { Option } = Select;
const { TextArea } = Input;

const StyledComplaintModule = styled.section`
padding-top: 25px;
.setpospin_instructions{
  ul{
    li{
    font-size: 16px;
    line-height: 40px;
    }
   }
}
.grey-btn{
  background: ${theme.btnGray} !important;
  color:${theme.LandingBlack} !important;
  border: 1px solid ${theme.webGray};
  font-size: 14px;
  padding: 6px 14px;
  line-height: normal;
  height: auto;
  &:hover{
    background: ${theme.lightWhite} !important;
  }
}
`;

const columns = [
  {
    title: 'Complaint ID',
    dataIndex: 'case_id',
    key: 'case_id',
  },
  {
    title: 'Description',
    dataIndex: 'remarks',
    key: 'remarks',
  },
  {
    title: 'Transaction Number',
    dataIndex: 'transaction_number',
    key: 'transaction_number',
  },
  {
    title: 'Reference Number',
    dataIndex: 'reference_number',
    key: 'reference_number',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
];

class ComplaintModule extends PureComponent {
  constructor() {
    super();
    this.state = { modalType: '' };
    this.handleModal = this.handleModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.onInitComplainModule({}, { actionType: 'LISTING', apiMethod: 'GET' });
  }

  componentWillReceiveProps(nextProps) {
    const { ComplainResponse: _ComplainResponse } = this.props;
    const { ComplainResponse, ComplainResponse: { status } } = nextProps;
    if (!utils.isEqual(ComplainResponse, _ComplainResponse) && status) {
      this.handleModal();
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const { form: { validateFields }, onInitComplainModule } = this.props;
    validateFields((err, values) => {
      if (!err) {
        onInitComplainModule(values, { apiMethod: 'POST', actionType: 'CREATE' });
      }
    });
  }

  handleModal(type) {
    this.setState({ modalType: typeof (type) === 'string' ? type : '' });
  }

  renderModalUI() {
    const { isLoadingStatus,
      form: { getFieldDecorator },
      ComplainTypeList: { complaint_types = [] },
    } = this.props;
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical">
        <Form.Item className="margin-b-1" label="Transaction Ref Number ">
          {getFieldDecorator('transaction_number', {
            rules: [validationRules.mandatory],
          })(
            <Input placeholder="Enter transaction number" />
          )}
        </Form.Item>
        <Form.Item className="margin-b-1" label="Complaint Type">
          {getFieldDecorator('complaint_code', {
            rules: [validationRules.mandatory],
          })(
            <Select placeholder="Select Complaint type">
              {complaint_types.map(({ complaint_code, complaint_label }) => (
                <Option
                  key={complaint_code}
                  value={complaint_code}
                >{complaint_label}
                </Option>))}
            </Select>
          )}
        </Form.Item>
        <Form.Item className="margin-b-1" label="Description">
          {getFieldDecorator('description', {
            rules: [validationRules.mandatory],
          })(
            <TextArea rows={4} placeholder="Description" />
          )}
        </Form.Item>
        <div className="text-right">
          <Button className="white-btn" onClick={this.handleModal}>
        Cancel
          </Button>
          <Button
            htmlType="submit"
            className="green-btn margin-l-1"
            loading={isLoadingStatus}
          >Raise Complaint
          </Button>
        </div>
      </Form>);
  }

  render() {
    const { isLoadingStatus,
      history,
      onInitComplainModule,
      ComplainList: { total_records, complaints = [] },
    } = this.props;
    const { modalType } = this.state;
    return (
      <StyledComplaintModule>
        <Modal
          visible={!!modalType}
          onCancel={this.handleModal}
          size="sm"
          classname="default-popup"
          title="New Request"
          footer={null}
          maskClosable={false}
        >
          {modalType && this.renderModalUI()}
        </Modal>
        <Container className="margin-t-2">
          <Row align="top" type="flex" gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-left">
              <h1 className="margin-b-1 font-20">Manage Zaggle Cards</h1>
              <Breadcrumb separator="<">
                <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
                <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Expense Benefits card</Breadcrumb.Item>
              </Breadcrumb>,
            </Col>
          </Row>
          <Card className="rounded card-padding-20 noborder noshadow">
            <Row align="top" type="flex" gutter={32} className="padding-l-3 padding-r-3">
              <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                <h1 className="margin-b-3 margin-r-3 font-20" style={{ display: 'inline-block' }}>Complaint Module</h1>
                <Button className="grey-btn" onClick={() => history.goBack()}><Icon type="left" />Back to Expense Benefits card</Button>
              </Col>
              <Col xs={24} sm={24} md={10} lg={10} xl={10} className="text-right">
                <Button
                  className="grey-btn"
                  onClick={() => {
                    this.handleModal('RAISE_COMPLAIN');
                    onInitComplainModule({}, { actionType: 'TYPE_LIST', apiMethod: 'GET' });
                  }}
                >Raise Complaint
                </Button>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Table
                  rowKey="case_id"
                  dataSource={complaints}
                  columns={columns}
                  loading={isLoadingStatus}
                  pagination={{ total_records, onChange: (page) => onInitComplainModule({ page }, { actionType: 'LISTING', apiMethod: 'GET' }) }}
                />
              </Col>
            </Row>
          </Card>
        </Container>
      </StyledComplaintModule>
    );
  }
}

ComplaintModule.propTypes = {
  isLoadingStatus: bool.isRequired,
  ComplainList: shape({}).isRequired,
  ComplainTypeList: shape({}).isRequired,
  history: shape({}).isRequired,
  form: shape({}).isRequired,
  ComplainResponse: shape({}).isRequired,
  onInitComplainModule: func.isRequired,
};
const mapDispatchToProps = (dispatch) => ({
  onInitComplainModule: (payload, otherParams) => dispatch(SetComplainModule(payload, otherParams)),
});

const mapStateToProps = createStructuredSelector({
  isLoadingStatus: select_isBoolean('isLoading'),
  ComplainList: select_cardBlockJS('complainList'),
  ComplainTypeList: select_cardBlockJS('complainTypeList'),
  ComplainResponse: select_cardBlockJS('complainResponse'),
});

const ComplaintModuleWrapper = Form.create({ name: 'normal_admin' })(ComplaintModule);
const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(ComplaintModuleWrapper));
export { ComplaintModule, mapStateToProps, mapDispatchToProps, ComplaintModuleWrapper };
export default component;



// WEBPACK FOOTER //
// client/containers/ComplaintModule/index.jsx